import { render, staticRenderFns } from "./DxPointForm.vue?vue&type=template&id=69a84e46&"
import script from "./DxPointForm.vue?vue&type=script&lang=js&"
export * from "./DxPointForm.vue?vue&type=script&lang=js&"
import style0 from "./DxPointForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports